import './App.css';
import AuthContext from './Context/authContext';
import AppContext from './Context/appContext';
import LayoutControl from './Pages/LayoutControl';

function App() {
  return (
    <AuthContext>
      <AppContext>
        <LayoutControl />
      </AppContext>
    </AuthContext>
  );
}

export default App;
